// extracted by mini-css-extract-plugin
module.exports = {"icon":"StripeWidget_icon__2Zl3Q"};